import { useContext, useState, useMemo, useRef, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useGlobalStore, ModalContext } from '../../components/contexts';
import ValidateService from '../../services/ValidateService';
import ReqVideoController from '../../controllers/aia/ReqVideoController';
import InputVideo from '../../components/inputComponents/InputVideo';
import UploadStatus from '../../components/videoComponents/UploadStatus';

const ReqVideo = () => {
  useEffect(() => {
    document.title = '유해요인조사관리 - 영상분석신청';
  }, []);
  const location = useLocation();
  const [pageParam, setPageParam] = useState({});

  const { store, updateStore } = useGlobalStore();
  const { modalService } = useContext(ModalContext);
  const validateService = new ValidateService(modalService);
  const naviagte = useNavigate();

  const [taskInfo, setTaskInfo] = useState([]);
  const [workList, setWorkList] = useState([]);

  const [btn1Active, setBtn1Active] = useState(false);
  const [btn2Active, setBtn2Active] = useState(false);
  const [btn3Active, setBtn3Active] = useState(false);

  const [uploadIng, setUploadIng] = useState(false);
  const [searchTimer, setSearchTimer] = useState(false);

  const controller = useMemo(() => {
    return new ReqVideoController(
      { store, updateStore },
      { pageParam, setPageParam },
      { taskInfo, setTaskInfo },
      { workList, setWorkList },
      modalService,
      validateService,
      naviagte
    );
  }, [store, modalService, validateService]);

  useEffect(() => {
    if (
      pageParam !== undefined &&
      pageParam !== null &&
      pageParam?.entSn !== undefined &&
      pageParam?.entSn !== null &&
      pageParam?.entSn !== '' &&
      pageParam?.aiaAplyId !== undefined &&
      pageParam?.aiaAplyId !== null &&
      pageParam?.aiaAplyId !== ''
    ) {
      controller.fnSearch();
    }
  }, [pageParam]);

  useEffect(() => {
    setPageParam({
      entSn: location.state?.entSn,
      aiaAplyId: location.state?.aiaAplyId,
    });
  }, [location]);

  useEffect(() => {
    if (searchTimer) {
      return;
    }

    let judge0 = false; // 업로드 파일 존재
    let judge1 = true; // 유효성 검사 완료
    let judge11 = false; // 분석신청 대기
    let judge2 = false; // AI영상분석중
    let judge25 = false; // AI영상분석 실패
    let judge3 = true; // AI영상분석 완료

    if (uploadIng) {
      return;
    } else {
      for (let index = 0; index < workList.length; index++) {
        const work = workList[index];

        if (work.vdoId?.length > 0) {
          judge0 = true;
        }

        if (work.vldScsYn !== 'Y') {
          judge1 = false;
        }
        if (work.vldErrId?.length > 0) {
          judge1 = false;
        }

        if (work.aiaScsStts === null) {
          judge11 = true;
        }

        if (['0', '1', '2', '3', '4'].includes(work.aiaScsStts)) {
          judge2 = true;

          if (work.aiaErrId?.length > 0) {
            judge25 = true;
          }
        }

        if (work.aiaScsStts !== '5') {
          judge3 = false;
        }
      }

      setBtn1Active(judge1);
      setBtn2Active(judge2);
      setBtn3Active(judge3);

      if (judge0) {
        if (!judge1) {
          controller.fnSearch();
          setSearchTimer(true);
          setTimeout(() => {
            setSearchTimer(false);
          }, 3000);
        } else {
          if (!judge11 && judge2 && !judge25) {
            controller.fnSearch();
            setSearchTimer(true);
            setTimeout(() => {
              setSearchTimer(false);
            }, 3000);
          }
        }
      }
    }
  }, [workList, uploadIng, searchTimer]);

  const uploadCallBack = value => {
    setUploadIng(value);

    if (!value) {
      controller.fnSearch();
    }
  };

  return (
    <>
      <div className="page-title-wrap" data-type="responsive">
        <h2 className="h-tit">유해요인조사관리 - 영상분석신청</h2>
      </div>
      <div className="tbl-wrap">
        <table className="tbl data row">
          <tbody>
            <tr>
              <th scope="row">공정</th>
              <td>
                <div className="input-group">{taskInfo?.taskNm}</div>
              </td>
              <th scope="row">조사일자</th>
              <td>
                <p>{taskInfo?.aplyYmd}</p>
              </td>
            </tr>
            <tr>
              <th scope="row">공정 상세내용</th>
              <td>
                <p>{taskInfo?.taskExpln}</p>
              </td>
              <th scope="row">조사자</th>
              <td>
                <p>{taskInfo?.aplyUser}</p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <ol className="step-wrap">
        <li className="done">
          <span>
            <span className="step-tit">부담작업 체크리스트 작성</span>
          </span>
        </li>
        <li className={`${!btn1Active ? 'active' : 'done'}`}>
          <span>
            <span className="step-tit">영상 업로드</span>
          </span>
        </li>
        <li
          className={`${btn1Active && btn2Active && !btn3Active && 'active'} ${
            btn1Active && !btn2Active && btn3Active && 'done'
          }`}
        >
          <span>
            <span className="step-tit">AI영상분석신청</span>
          </span>
        </li>
        <li className={`${btn1Active && !btn2Active && btn3Active && 'done'}`}>
          <span>
            <span className="step-tit">AI영상분석완료</span>
          </span>
        </li>
        <li>
          <span>
            <span className="step-tit">유해요인 기본조사표 작성</span>
          </span>
        </li>
      </ol>
      <div className="tbl-wrap">
        <h3 className="block-tit">영상 업로드</h3>
        <p className="tbl-msg">
          <em className="star-require">*</em> mp4, avi, mov, mkv 파일만 업로드
          가능합니다.
        </p>
        <table className="tbl row data">
          <tbody>
            <tr>
              <th className="bg1">구분</th>
              <th className="bg1">영상 분석 진행사항</th>
            </tr>
            {workList?.length > 0 &&
              workList.map(work => {
                return (
                  <tr key={work.workId}>
                    <th>{work?.workNm}</th>
                    <td>
                      <div className="input-group">
                        <InputVideo
                          modalService={modalService}
                          anlsAplyId={work?.aiaAplyId}
                          taskId={work?.taskId}
                          workId={work?.workId}
                          vdoId={work?.vdoId ?? ''}
                          vldScsYn={work?.vldScsYn}
                          vldErrId={work?.vldErrId}
                          aiaScsStts={work?.aiaScsStts}
                          aiaErrId={work?.aiaErrId}
                          callBackFunc={value => {
                            uploadCallBack(value);
                          }}
                        />
                        {work.vdoId?.length > 0 && (
                          <>
                            {/* 유효성 검사 상태 */}
                            {work.vldScsYn === 'N' ? (
                              !work.vldErrId?.length > 0 && (
                                <UploadStatus
                                  text="유효성 검사중"
                                  isLoading={true}
                                  isError={false}
                                />
                              )
                            ) : (
                              <>
                                <UploadStatus
                                  text={
                                    work?.vldErrId?.length > 0
                                      ? `유효성 검사 실패 ${
                                          work?.vldErrId === 'V0001'
                                            ? '- 영상 화질 검사 탈락'
                                            : work?.vldErrId === 'V0002'
                                            ? '- 파일용량 250MB 초과'
                                            : work?.vldErrId === 'V0003'
                                            ? '- 작업자 식별 실패'
                                            : work?.vldErrId === 'V0004'
                                            ? '- 작업자 크기가 너무 작습니다.'
                                            : work?.vldErrId === 'V0005'
                                            ? '- 파일이 존재하지 않음'
                                            : work?.vldErrId === 'V0006'
                                            ? '- 영상 길이 5초 이하'
                                            : work?.vldErrId === 'V0010'
                                            ? '- 영상 파일 깨짐'
                                            : ''
                                        }`
                                      : '유효성 검사 완료'
                                  }
                                  isComplete={true}
                                  isError={work?.vldErrId?.length > 0}
                                />

                                {work.aiaScsStts !== null &&
                                  work.aiaScsStts !== '' &&
                                  ['0', '1', '2', '3', '4'].includes(
                                    work.aiaScsStts
                                  ) && (
                                    <UploadStatus
                                      text={
                                        work?.aiaErrId?.length > 0
                                          ? `AI영상분석 실패 ${
                                              work?.aiaErrId === 'E0107'
                                                ? ' - 비식별화 처리 실패'
                                                : work?.aiaErrId === 'E0108'
                                                ? ' - 요청 파일 없음'
                                                : work?.aiaErrId === 'E0207'
                                                ? ' - 자세분석 실패'
                                                : ' - 관리자에게 문의바랍니다.'
                                            }`
                                          : 'AI영상분석중'
                                      }
                                      isLoading={!(work?.aiaErrId?.length > 0)}
                                      isComplete={work?.aiaErrId?.length > 0}
                                      isError={work?.aiaErrId?.length > 0}
                                    />
                                  )}

                                {work.aiaScsStts !== null &&
                                  work.aiaScsStts !== '0' &&
                                  work.aiaScsStts !== '' &&
                                  work.aiaScsStts === '5' && (
                                    <UploadStatus
                                      text={
                                        work?.aiaErrId?.length > 0
                                          ? `AI영상분석 실패 ${
                                              work?.aiaErrId === 'E0107'
                                                ? ' - 비식별화 처리 실패'
                                                : work?.aiaErrId === 'E0108'
                                                ? ' - 요청 파일 없음'
                                                : work?.aiaErrId === 'E0207'
                                                ? ' - 자세분석 실패'
                                                : ' - 관리자에게 문의바랍니다.'
                                            }`
                                          : 'AI영상분석 완료'
                                      }
                                      isComplete={true}
                                      isError={work?.aiaErrId?.length > 0}
                                    />
                                  )}
                              </>
                            )}
                          </>
                        )}
                      </div>
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
      <div className="page-btn-wrap both">
        <p>모든 작업의 영상 유효성 검사가 완료되면 신청버튼이 활성화됩니다.</p>
        {btn1Active && !btn2Active && !btn3Active ? (
          <button
            type="button"
            className="btn xlg primary"
            onClick={() => {
              controller.fnApply();
            }}
          >
            신청하기
          </button>
        ) : (
          <button type="button" className="btn xlg primary" disabled>
            신청하기
          </button>
        )}
        <button
          type="button"
          className="btn xlg secondary"
          onClick={() => {
            controller.fnGoToPrevPage();
          }}
        >
          (이전) 부담작업체크리스트
        </button>

        {btn1Active && !btn2Active && btn3Active ? (
          <>
            <button
              type="button"
              className="btn xlg primary"
              onClick={() => {
                controller.fnGoToNextPage();
              }}
            >
              (다음) 유해요인기본조사표
            </button>
          </>
        ) : (
          <>
            <button type="button" className="btn xlg primary" disabled>
              (다음) 유해요인기본조사표
            </button>
          </>
        )}
      </div>
    </>
  );
};

export default ReqVideo;
